import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFacebook = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 26,
	viewBox: "0 0 25 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.5,
			cy: 13,
			r: 12,
			stroke: "#003B6F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8752 7.00002C14.2056 7.00002 14.538 7.01714 14.8679 7.03132C15.083 7.04012 15.298 7.06996 15.5 7.09099L15.4849 9.02349H15.3267C15.1082 9.02349 14.8901 9.02056 14.672 9.02056C14.5083 9.02056 14.3446 9.02056 14.1804 9.02741C13.6536 9.04452 13.2653 9.23674 13.2381 9.87602C13.2215 10.3368 13.2094 11.3541 13.2089 11.4074C13.2361 11.4074 13.7574 11.4074 14.2817 11.4074C14.5441 11.4074 14.8004 11.4074 14.9787 11.4074H15.4048C15.298 12.1494 15.1998 12.8621 15.0936 13.5786H13.2094L13.1671 19H10.8504L10.8927 13.5708H9L9.01712 11.4123H10.9189V11.25C10.9224 10.8151 10.9189 10.3798 10.9335 9.94499C10.9359 9.66773 10.9601 9.39107 11.006 9.1174C11.0569 8.79662 11.1727 8.48881 11.3468 8.21177C11.5209 7.93472 11.7498 7.69393 12.0203 7.50332C12.5104 7.17376 13.0928 6.99809 13.6889 7.00002C13.7524 7.0005 13.8138 7.00002 13.8752 7.00002Z",
			fill: "#003B6F"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6,
			y: 6.5,
			width: 13,
			height: 13,
			rx: 4,
			fill: "#003B6F"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_13741_27034)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M13.777 8.35695C14.0838 8.35695 14.3925 8.37285 14.6988 8.38602C14.8985 8.39419 15.0982 8.42189 15.2857 8.44142L15.2717 10.2359H15.1248C14.9219 10.2359 14.7194 10.2332 14.5169 10.2332C14.3649 10.2332 14.2129 10.2332 14.0604 10.2395C13.5712 10.2554 13.2107 10.4339 13.1854 11.0275C13.17 11.4554 13.1588 12.4001 13.1583 12.4496C13.1835 12.4496 13.6676 12.4496 14.1544 12.4496C14.3981 12.4496 14.6361 12.4496 14.8017 12.4496H15.1973C15.0982 13.1386 15.007 13.8003 14.9083 14.4657H13.1588L13.1195 19.4998H10.9682L11.0075 14.4584H9.25L9.2659 12.4541H11.0318V12.3033C11.0351 11.8996 11.0318 11.4953 11.0454 11.0916C11.0476 10.8341 11.0701 10.5772 11.1127 10.3231C11.16 10.0252 11.2675 9.7394 11.4292 9.48215C11.5909 9.22489 11.8034 9.0013 12.0546 8.8243C12.5097 8.51828 13.0505 8.35516 13.604 8.35695C13.6629 8.3574 13.72 8.35695 13.777 8.35695Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_13741_27034",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 11.1429,
				height: 11.1429,
				fill: "white",
				transform: "translate(6.92773 8.35693)"
			})
		}) })
	]
});
export default SvgFacebook;
